const permissionList = [
    { key: "dashboards", label: "Dashboard" },
    { key: "super_admin", label: "Super Admin" },
    { key: "ambassador_profile", label: "Ambassador profile" },
    { key: "intern", label: "Intern" },
    { key: "quick_actions", label: "Quick Actions" },
    { key: "users_counts", label: "User Counts" },
    { key: "sales_statistics", label: "Sales Statistics" },
    { key: "doubt_support_statistics", label: "Doubt support Statistics" },
    { key: "customer_support_statistics", label: "Customer support Statistics" },
    { key: "placement_support_statistics", label: "Placement support Statistics" },
    { key: "leave_request_statistics", label: "leave request Statistics" },
    { key: "leads_statistics", label: "Leads Statistics" },
    { key: "users", label: "Users" },
    { key: "team", label: "Team" },
    { key: "students", label: "Students" },
    { key: "interns", label: "Interns" },
    { key: "trainers", label: "Trainers" },
    { key: "companies", label: "Companies" },
    { key: "purchase_price", label: "Purchase Price" },
    { key: "transactions", label: "Transactions" },
    { key: "leads", label: "Leads" },
    { key: "customer_support", label: "Customer Support" },
    { key: "whatsapp_chat", label: "Whatsapp Chat" },
    { key: "doubt_support", label: "Doubt Support" },
    { key: "users_management", label: "Users Management" },
    { key: "students_management", label: "Students Management" },
    { key: "team_management", label: "Team Management" },
    { key: "interns_management", label: "Interns Management" },
    { key: "community_management", label: "Community Management" },
    { key: "quiz_management", label: "Quiz Management" },
    { key: "team_tasks", label: "Team tasks" },
    { key: "student_tasks", label: "Student tasks" },
    { key: "courses_management", label: "Courses Management" },
    { key: "internships_management", label: "Internships Management" },
    { key: "placement_support", label: "Placement Support" },
    { key: "videos_management", label: "Videos Management" },
    { key: "classes_management", label: "Classes Management" },
    { key: "idcard_management", label: "Idcard Management" },
    { key: "certificate_management", label: "Certificate Management" },
    { key: "activity_management", label: "Activity Management" },
    { key: "expenses_management", label: "Expenses Management" },
    { key: "mock_tests_management", label: "Mocktests Management" },
    { key: "resources_management", label: "Resources Management" },
    { key: "interview_kits_management", label: "Interviewkits Management" },
    { key: "course_cheat_sheets", label: "Coursecheat Sheets" },
    { key: "technical_quiz_management", label: "Technicalquiz Management" },
    { key: "team_milestones_management", label: "Team milestones Management" },
    { key: "coupon_codes_management", label: "Couponcodes Management" },
    { key: "add_remainders", label: "Add Remainders" },
    { key: "view_remainders", label: "View Remainders" },
    { key: "add_lead", label: "Add Lead" },
    { key: "add_team_task", label: "Addteam Task" },
    { key: "view_team_task", label: "View team Task" },
    { key: "delete_team_task", label: "Deleteteam Task" },
    { key: "evaluate_team_task", label: "Evaluateteam Task" },
    { key: "add_team_milestone", label: "Addteam Milestone" },
    { key: "leaves_management", label: "Leaves Management" },
    { key: "team_attendance_management", label: "Team attendance Management" },
    { key: "approve_leaves", label: "Approve Leaves" },
    { key: "upload_video", label: "Upload Video" },
    { key: "student_attendance", label: "Student Attendance" },
    { key: "website_settings", label: "Website Settings" },
    { key: "team_permissions", label: "Team Permissions" },
    { key: "view_team_targets", label: "Viewteam Targets" },
    { key: "add_team_targets", label: "Addteam Targets" },
    { key: "delete_team_targets", label: "Deleteteam Targets" },
    { key: "team_meetings", label: "Team Meetings" },
    { key: "add_team_meeting", label: "Addteam Meeting" },
    { key: "delete_team_meeting", label: "Deleteteam Meeting" },
    { key: "student_phone", label: "Student Phone" },
    { key: "student_email", label: "Student Email" },
    { key: "student_whatsapp", label: "Student Whatsapp" },
    { key: "upcoming_classes", label: "Upcomimg Classes" },
    { key: "website_log", label: "Website Log" },
    { key: "active_batches", label: "Active Batches" },
    { key: "shorts_management", label: "Shortsm Management" },
    { key: "hacking_workshop_leads", label: "Hacking Workshop Leads" },
    { key: "hacking_internship_leads", label: "Hacking Internship Leads" },
    { key: "start_class", label: "Start Class" },
    { key: "upload_class_recording", label: "Upload Class Recording" },
    { key: "edit_class_topic", label: "Edit Class Topic" },
    { key: "share_class_meeting_link", label: "Share Class Meeting Link" },
    { key: "preview_class_recording", label: "Preview Class Recording" },
    { key: "share_class_recording", label: "Share Class Recording" },
    { key: "delete_class_schedule", label: "Delete Class Schedule" },
    { key: "batch_overview", label: "Batch Overview" },
    { key: "batch_attendance", label: "Batch Attendance" },
    { key: "batch_classes", label: "Batch Classes" },
    { key: "batch_assignments", label: "Batch Assignments" },
    { key: "batch_projects", label: "Batch Projects" },
    { key: "batch_assignment_submissions", label: "Batch Assignment Submissions" },
    { key: "batch_project_submissions", label: "Batch Project Submissions" },
    { key: "add_batch_report", label: "Add Batch Report" },
    { key: "add_class_schedule", label: "Add Class Schedule" },
    { key: "add_assignment", label: "Add Assignment" },
    { key: "delete_assignment", label: "Delete Assignment" },
    { key: "evaluate_assignment", label: "Evaluate Assignment" },
    { key: "edit_assignment", label: "Edit Assignment" },
    { key: "add_project", label: "Add Project" },
    { key: "delete_project", label: "Delete Project" },
    { key: "edit_project", label: "Edit Project" },
    { key: "delete_project_submission", label: "Delete Project Submission" },
    { key: "evaluate_project_submission", label: "Evaluate Project Submission" },
    { key: "view_batch_students", label: "View Batch Students" },
    { key: "team_overview", label: "Team Overview" },
    { key: "initiate_placement_support", label: "Initiate Placement Support" },
    { key: "edit_lead", label: "Edit Lead" },
    { key: "mark_lead_interested", label: "Mark Lead Interested" },
    { key: "mark_lead_scheduled", label: "Mark Lead Scheduled" },
    { key: "mark_lead_pendingpayment", label: "Mark Lead Pendingpayment" },
    { key: "mark_lead_joined", label: "Mark Lead Joined" },
    { key: "view_scheduled_leads", label: "View Scheduled Leads" },
    { key: "view_interested_leads", label: "View Interested Leads" },
    { key: "view_notintrested_leads", label: "View Notintrested Leads" },
    { key: "view_pending_payment_leads", label: "View Pending Payment Leads" },
    { key: "view_joined_leads", label: "View Joined Leads" },
    { key: "students_list", label: "Students List" },
    { key: "assignment_submissions", label: "Assignment Submissions" },
    { key: "project_submissions", label: "Project Submissions" },
    { key: "edit_team_profile", label: "Edit Team Profile" },
    { key: "doubts", label: "Doubts" },
    { key: "courses", label: "Courses" },
    { key: "all_batches", label: "All Batches" },
    { key: "all_class_schedules", label: "All Class Schedules" },
    { key: "recordings", label: "Recordings" },
    { key: "fee_payments", label: "Fee Payments" },
    { key: "team_list", label: "Team List" },
    { key: "view_joined_leads", label: "View Joined Leads" },
    { key: "posts", label: "Posts" },
    { key: "comments", label: "Comments" },
    { key: "messages", label: "Messages" },
    { key: "student_support", label: "Student Support" },
    { key: "placement_support", label: "Placement Support" },
    { key: "intenships", label: "Intenships" },
    { key: "intenship_applications", label: "Intenship Applications" },
    { key: "tutorials", label: "Tutorials" },
    { key: "shorts", label: "Shorts" },
    { key: "super_admin_dashboard", label: "Super Admin Dashboard" },
    { key: "payments", label: "Payments" },
    { key: "daily_reports", label: "Daily Reports" },
    { key: "security", label: "Security" },
    { key: "coupon_codes", label: "Coupon Codes" },
    { key: "withdrawls", label: "Withdrawls" },
    { key: "sign_in", label: "Sign In" },
    { key: "create_invoice_2", label: "Create Invoice-2" },
    { key: "invoices_list", label: "Invoices List" },
    { key: "project_overview", label: "Project Overview" },
    { key: "course_registrations", label: "Course Registrations" },
    { key: "user_lists", label: "User Lists" },
    { key: "analytics", label: "Analytics" },
    { key: "projects_dashboard", label: "Projects Dashboard" },
    { key: "workshop_registrations", label: "Workshop Registrations" },
    { key: "campus_ambassadors", label: "Campus Ambassadors" },
    { key: "job_hunt", label: "Job Hunt" },
    { key: "wallet", label: "Wallet" },
    { key: "upload_videos", label: "Upload Videos" },
    { key: "tasks", label: "Tasks" },
    { key: "attendence", label: "Attendence" },
    { key: "leaves", label: "Leaves" },
    { key: "meetings", label: "Meetings" },
    { key: "team_leaderboard", label: "Team Leaderboard" },
    { key: "upload_shorts_video", label: "Upload Shorts Video" },
    { key: "course_overview", label: "Course Overview" },
    { key: "batch_course", label: "Batch Course" },
    { key: "syllabus", label: "Syllabus" },
    { key: "course_resources", label: "Course Resources" },
    { key: "course_certifications", label: "Course Certifications" },
    { key: "mock_tests", label: "Mock Tests" },
    { key: "technical_quizzes", label: "Technical_Quizzes" },
    { key: "edit_profile", label: "Edit Profile" },
    { key: "download_shorts_data", label: "Download Shorts Data" },
    { key: "edit_video", label: "Edit Video" },
    { key: "delete_video", label: "Delete Video" },
    { key: "edit_student_profile", label: "Edit Student Profile" },
    { key: "view_class_recording", label: "View Class Recording" },
    { key: "student_reports", label: "Student Reports" },
    { key: "student_idcards", label: "Student Idcards" },
    { key: "student_profect_submissions", label: "Student Profect Submissions" },
    { key: "personal_badges", label: "Personal Badges" },
    { key: "student_assignment_submissions", label: "Student Assignment Submissions" },
    { key: "student_doubts", label: "Student Doubts" },
    { key: "student_project_submissions", label: "Student Project Submissions" },
    { key: "activate_course", label: "Activate Course" },
    { key: "mark_course_refunded", label: "Mark Course Refunded" },
    { key: "refund_course", label: "Refund Course" },
    { key: "mark_course_not_interested", label: "Mark Course Not Interested" },
    { key: "pause_course", label: "Pause Course" },
    { key: "delete_course_payment", label: "Delete Course Payment" },
    { key: "initiate_student_support", label: "Initiate Student Support" },
    { key: "close_student_support", label: "Close Student Support" },
    { key: "delete_student_support", label: "Delete Student Support" },
    { key: "course_badges", label: "Course Badges" },
    { key: "screen_shots", label: "Screen Shots" },
    { key: "reschedule_class", label: "Reschedule Class" },
    { key: "recent_recordings", label: "Recent Recordings" },
    { key: "test", label: "Test" },
    { key: "class_feedbacks", label: "Class Feedbacks" },
    { key: "payment_screenshots", label: "Payment Screenshots" },
    { key: "customer_support_admin", label: "Customer Support Admin" },
    { key: "marketing", label: "Marketing" },
    { key: "placement_cell_leaderboard", label: "Placement Cell Leaderboard" },
    { key: "quiz_attempts", label: "Quiz Attempts" },
    { key: "mile_stone", label: "Mile Stone" },
    { key: "whatsapp_support", label: "Whatsapp Support" },
    { key: "college_registrations", label: "College Registrations" },
    { key: "add_daily_report", label: "Add Daily Report" },
    { key: "job_applications", label: "Job Applications" },
    { key: "create_invoice_1", label: "Create Invoice-1" },
    { key: "products", label: "Products" },
    { key: "chat", label: "Chat" },
    { key: "job_dashboard", label: "Job Dashboard" },
    { key: "edit_course", label: "Edit Course" },
    { key: "notifications", label: "Notifications" },
    { key: "about", label: "About" },
    { key: "permissions", label: "Permissions" },
    { key: "add_internships", label: "Add Internships" },
    { key: "batch_management", label: "Batch Management" },
    { key: "complete_analytics", label: "Complete Analytics" },
    { key: "projects", label: "Projects" },
    { key: "videos", label: "Videos" },
    { key: "upload_image", label: "Upload Image" },
    { key: "get_images", label: "Get Images" },
    { key: "placement_students", label: "Placement Students" },
    { key: "add_students", label: "Add Students" },
    { key: "team_members_all", label: "Team Members All" },
    { key: "add_courses", label: "Add Courses" },
    { key: "add_batch", label: "Add Batch" },
    { key: "reviews", label: "Reviews" },
    { key: "batches", label: "Batches" },
    { key: "internship_list", label: "Internship List" },
    { key: "update_shorts", label: "Update Shorts" },
    { key: "team_member", label: "Team Member" },
    { key: "hacking_workshop_registrations", label: "Hacking Workshop Registrations" },
    { key: "hacking_internship_registrations", label: "Hacking Internship Registrations" },
    { key: "team_leaves", label: "Team Leaves" },
    { key: "contact", label: "Contact" },
    { key: "create_certificates", label: "Create Certificates" },
    { key: "free_resources", label: "Free Resources" },
    { key: "all_charts", label: "All Charts" },
    { key: "assignment_submission_chart", label: "Assignment Submission Chart" },
    { key: "totalcourseregistrations_chart", label: "Totalcourseregistrations Chart" },
    { key: "projectsubmission_chart", label: "Projectsubmission Chart" },
    { key: "users_chart", label: "Users Chart" },
    { key: "upcoming_class", label: "Upcoming Class" },
    { key: "paymentstatus_chart", label: "Paymentstatus Chart" },
    { key: "paymentpay_chart", label: "Paymentpay Chart" },
    { key: "amountstatus_chart", label: "Amountstatus Chart" },
    { key: "leads_chart", label: "Leads Chart" },
    { key: "studentsupport_chart", label: "Studentsupport Chart" },
    { key: "upload_team_image", label: "Upload Team Image" },
    { key: "image_internal_manager", label: "Image Internal Manager" },
    { key: "course_registration_status_chart", label: "Course Registration Status Chart" },
    { key: "course_registration_chart", label: "Course Registration Chart" },
    { key: "customer_support_chart", label: "Customer Support Chart" },
    { key: "doubt_support_chart", label: "Doubt Support Chart" },
    { key: "placement_support_chart", label: "Placement Support Chart" },
    { key: "student_support_chart", label: "Student Support Chart" },
    { key: "mentors", label: "Mentors" },
    { key: "company", label: "Company" },
    { key: "ebooks", label: "Ebooks" },
    { key: "bug_bounty", label: "Bug Bounty" },    
    { key: "hacking_challenge", label: "Hacking Challenge" }, 
       { key: "teams_groups", label: "Teams Groups" }, 
       { key: "change_password", label: "Change Password" }, 
       { key: "otp_page", label: "Otp Page" }, 
       { key: "password_success", label: "Password Success" }, 

  ];
  export default permissionList;